<template>
    <div>
        <header-kravicka
                @updateProfil="emitUpdateProfil"
                :profil="profil"
        />

        <main>

            <div class="container">

                <div class="row justify-content-center">

                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 mb-5 mb-lg-0">

                        <h2>Tabuľka najlepších hráčov</h2>
                        <span class="customLabel">Skladanie obrázka</span>
                        <p class="mb-4 scoreDescription">Každý súťaživý hráč sa raz nájde v tabuľke najlepších hráčov.<br>Veľa šťastia, kamaráti!</p>

                        <router-link
                                class="btn --primary --large --startGame"
                                :to="{ name: 'slider-settings', params: { kravicka_id: $route.params.kravicka_id } }"
                        >
                            <span class="icon"></span>Spustiť hru
                        </router-link>

                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8">

                        <nav>

                            <div class="nav nav-tabs" id="nav-tab" role="tablist">

                                <template v-for="(sliderPuzzleObtiaznost, index) in sliderPuzzleObtiaznosti">

                                    <button
                                        class="nav-item nav-link"
                                        :class="{'active': sliderPuzzleObtiaznost.id === selectedObtiaznost}"
                                        @click="changeObtiaznost(sliderPuzzleObtiaznost.id)"
                                    >
                                        <span>{{ index + 1 }}.</span> {{ sliderPuzzleObtiaznost.slider_puzzle_obtiaznost_nadpis }}
                                    </button>

                                </template>

                            </div>

                        </nav>

                        <div class="tab-content" id="nav-tabContent">

                            <div class="tab-pane fade show active">

                                <table>

                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Hráč</th>
                                            <th class="text-right">Počet ťahov</th>
                                            <th class="text-right">Čas</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(leader, index) in leaders">
                                            <td>{{ index + 1}}</td>
                                            <td class="name">{{ leader.pouzivatel_id.pouzivatel_name }}</td>
                                            <td class="text-right">{{ leader.slider_puzzle_leaderboard_pocet_tahov}}</td>
                                            <td class="text-right time">{{ getTime(leader.slider_puzzle_leaderboard_cas) }}</td>
                                        </tr>
                                    </tbody>

                                </table>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </main>

        <div class="pexesoFooter --right">

            <router-link
                    class="btn --primary closeGame"
                    :to="{ name: 'kravicka', params: { kravicka_id: $route.params.kravicka_id } }"
            >
                <span class="icon"></span>
            </router-link>

        </div>

    </div>

</template>

<script>
    import EventService from '@/services/EventService.js'
    import HeaderKravicka from "../partials/HeaderKravicka.vue"

    export default {
        components: {HeaderKravicka},
        props: [
            'profil',
        ],
        data() {
            return {
                sliderPuzzleObtiaznosti: [],
                selectedObtiaznost: '',
                leaders: []
            }
        },
        mounted() {
            this.toggleBodyClass('addClass', 'pexeso')
            this.toggleBodyClass('addClass', '--score')

            this.getObtiaznosti()
        },
        destroyed() {
            this.toggleBodyClass('removeClass', 'pexeso')
            this.toggleBodyClass('removeClass', '--score')
        },
        computed: {
        },
        methods: {

            getObtiaznosti() {
                EventService.getSliderPuzzleObtiaznosti()
                    .then(response => {
                        this.sliderPuzzleObtiaznosti = response.data.data
                        this.selectedObtiaznost = this.sliderPuzzleObtiaznosti[0].id
                        this.getLeaderboard()
                    })
            },

            getLeaderboard() {
                EventService.getSliderPuzzleLeaderboard(this.selectedObtiaznost)
                    .then(response => {
                        this.leaders = response.data.data
                    })
            },

            changeObtiaznost(obtiaznost_id) {
                this.leaders = []
                this.selectedObtiaznost = obtiaznost_id
                this.getLeaderboard()
            },

            getTime(miliseconds) {
                let hours = Math.floor(miliseconds / 1000 / 60 / 60)
                miliseconds -= hours * 1000 * 60 * 60

                let minutes = Math.floor(miliseconds / 1000 / 60)
                miliseconds -= minutes * 1000 * 60

                let seconds = Math.floor(miliseconds / 1000)
                miliseconds -= seconds * 1000

                let tenths = Math.floor(miliseconds / 100)

                return this.formatTime(minutes) + ':' + this.formatTime(seconds) + '.' + tenths
            },

            formatTime(timeInt) {
                return ('0'  + timeInt).slice(-2)
            },

            // mounted + destroy
            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            },

            emitUpdateProfil() {
                this.$emit('updateProfil')
            },
        }
    }

</script>